<template>
  <div class="rowDetail">
    <div class="rowDetail-title">
      ПАРАМЕТРЫ РЯДА
    </div>
    <ul class="rowDetail-params">
      <li>Высота стеллажей: {{ data.height }}</li>
      <li>Глубина стеллажей: {{ data.depth }}</li>
    </ul>
    <button @click="$emit('edit')">
      Изменить
    </button>
    <template v-if="!data.separate">
      <div class="rowDetail-title">
        БОКОВЫЕ СТЕНКИ РЯДА
        <Info>
          У конструкций на общих стойках боковые стенки могут выбраны только у крайних стеллажей справа и слева.
        </Info>
      </div>
      <ul class="rowDetail-params">
        <li>Слева: {{ data.side_wall_left ? 'да' : 'нет' }}</li>
        <li>Справа: {{ data.side_wall_right ? 'да' : 'нет' }}</li>
      </ul>
      <button @click="$emit('edit-side')">
        Изменить
      </button>
    </template>
    <div class="rowDetail-divider" />
    <ul class="rowDetail-params rowDetail-params_gray">
      <li>Длина ряда: {{ rowWidth }}</li>
      <li>Стеллажей: {{ sections.length }}</li>
    </ul>
    <div class="rowDetail-priceLabel">
      Стоимость ряда:
    </div>
    <div class="rowDetail-price">
      {{ price }} {{ priceSymbol }}
    </div>
    <a
      class="rowDetail-calculation"
      href="#accessories"
    >Посмотреть расчет</a>
    <div class="rowDetail-hint">
      Обратите внимание: изображение стеллажей — схематичное
    </div>
  </div>
</template>

<script>
  import Info from './Info.vue';

  export default {
    name: 'RowDetail',
    components: {
      Info,
    },
    props: {
      data: Object,
      rowWidth: Number,
      sections: Array,
      price: {
        type: [Number, String],
        default: 0,
      },
      priceSymbol: String,
      rackWidth: {
        type: Number,
        default: 6,
      },
    },
  }
</script>

<style>
  .rowDetail {
    padding: 8px 32px 32px;
    width: 264px;
    font-size: 14px;
    background: #F6F6F6;
  }
  .rowDetail a {
    text-decoration: none;
    color: #0A53B3;
  }
  .rowDetail-title {
    margin-top: 24px;
    margin-bottom: 16px;
    font-family: Oswald, Roboto, sans-serif;
    font-weight: 500;
    font-size: 16px;
    text-transform: uppercase;
    color: #A7A7A7;
  }
  .rowDetail-subtitle {
    margin-bottom: 32px;
    font-family: Oswald, Roboto, sans-serif;
    font-weight: 500;
    line-height: 21px;
    text-transform: uppercase;
    color: #A7A7A7;
  }
  .rowDetail-subtitle:not(:first-child) {
    margin-top: 66px;
  }
  .rowDetail-divider {
    margin: 24px 0;
    border-top: 1px solid #DDDDDD;
  }
  .rowDetail-params {
    margin: 16px 0;
    padding: 0;
    list-style: none;
    font-size: 14px;
    font-weight: bold;
  }
  .rowDetail-params_gray {
    color: #A7A7A7;
  }
  .rowDetail-params > li {
    margin: 8px 0;
  }
  .rowDetail-priceLabel {
    font-weight: bold;
    font-size: 18px;
    text-transform: uppercase;
  }
  .rowDetail-price {
    margin-bottom: 16px;
    font-weight: bold;
    font-size: 30px;
  }
  a.rowDetail-calculation {
    display: inline-block;
    padding: 8px 36px 8px 16px;
    color: white;
    background: #0B53B3 url(../../public/icons/arrow-down.svg) calc(100% - 16px) 50% no-repeat;
  }
  .rowDetail-hint {
    margin-top: 16px;
    color: #A7A7A7;
  }
</style>
